import Vue from 'vue';
import helpers from './mixins/helpers';
if(document.getElementById('test-page')) {
    let test = new Vue({
        mixins: [helpers],
        el: "#test-page",
        data: {
            test: null,
            steps: 0,
            currentStep: 1,
            result: null,
            netMessage: false,
            startTime: Date.now(),
            endTime: null,
            showBanner: true,
            countdown: {
                enable: false,
                message: null,
                seconds: 0
            },
            load: false
        },
        methods: {
            fetchData () {
                let self = this;
                try {

                    $.ajax({
                        url: '/api/v1/test/view',
                        dataType: "json",
                        data: {id: test_id},
                        success: function (data) {
                            self.test = data;
                            self.steps = data.questions.length;

                            if (self.test.time > 0) {

                                self.countdown.enable = true;

                                self.countdown.seconds = self.test.time * 60;

                                setInterval(function () {
                                    self.countDown();
                                }, 1000);

                            }

                            sendEvent.testStart(data.lection_id)
                        },
                        fail: function () {

                            throw new Error('Ошибка получении данных');

                        }
                    });

                } catch (e) {
                    console.error(e);

                }
            },
            nextStep (step) {
                let self = this;



                if (!step) {

                    if ($("#step-" + self.currentStep).find('input:checked').length > 0 ) {
                        $('.answer-title').removeClass('novalue');
                        self.currentStep++;


                    } else {
                        $('.answer-title').addClass('novalue');

                    }

                } else {

                    self.currentStep = step;

                }

            },
            getResult () {
                if (this.netMessage === false) {
                    let self = this;

                    this.endTime = Date.now();

                    let $formData = $("#test").serialize();

                    $.ajax({
                        url: '/tests/test/get-result',
                        dataType: "json",
                        method: 'POST',
                        data: {
                            id: $("#test-id").val(),
                            data: $formData,
                            time: Math.floor((self.endTime - self.startTime) / 1000)
                        },
                        success: function (data) {

                            self.result = data;
                            self.countdown.enable = false;
                            self.countdown.seconds = 0;
                            self.load = false;

                            sendEvent.testEnd(self.test.lection_id);

                            if(data.message && data.message.nmo_code){
                                sendEvent.newNmoCode(self.test.lection_id);
                                // sendEvent.action('User get code NMO', self.test.lection_id, 'lection');
                            }
                            if (data.showReview) {
                                $('#reviewModal').modal('show').find('.modal-content').load('/reviews/new',{'code': data.reviewCode});
                            }

                        },
                        fail: function () {

                            throw new Error('Ошибка получении данных');

                        }
                    });

                }

            },
            countDown () {
                let self = this;
                if (this.countdown.seconds === 0 && this.countdown.enable === true) {

                    this.countdown.enable = false;
                    this.getResult();

                } else if (this.countdown.seconds > 0) {
                    let message = '';
                    let time = new Date(this.countdown.seconds * 1000);
                    if (time.getUTCHours() > 0) {
                        let hourse = time.getUTCHours();
                        message += hourse + ' ' + self.decOfNum(hourse, ['час', 'часа', 'часов']) + ' ';
                    }
                    if (time.getMinutes() > 0) {
                        let minute = time.getMinutes();
                        message += minute + ' ' + self.decOfNum(minute, ['минута', 'минуты', 'минут']) + ' ';

                    }
                    let seconds = time.getSeconds();

                    message += seconds + ' ' + self.decOfNum(seconds, ['секунда', 'секунды', 'секунд']);

                    this.countdown.seconds--;

                    this.countdown.message = message;

                }

            },
            returnFocus () {
                $('.next-btn').focus();


            }
        },
        mounted () {
            this.fetchData();
        }

    });
    Offline.on('confirmed-up',function () {

        test.netMessage = false;
    });
    Offline.on('confirmed-down',function () {

        test.netMessage = true;

    });
}
